module.exports = __webpack_public_path__ + "img/top-home-service.8dd2660.jpg";